import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  newsList: [],
  selectNews: "",
  viewNews: "",
  isOpenAddUpdateNewsModal: false,
  isOpenNewsViewModal: false,
  isOpenNewsCommentModal: false,
};

const NewsReducer = createSlice({
  name: "NewsReducer",
  initialState: initialState,
  reducers: {
    setNewsList: (state, { payload }) => {
      return {
        ...state,
        newsList: payload,
      };
    },
    setNews: (state, { payload }) => {
      console.log("payload", payload);
      return {
        ...state,
        selectNews: payload,
      };
    },
    setViewNews: (state, { payload }) => {
      console.log("payload", payload);
      return {
        ...state,
        viewNews: payload,
      };
    },
    openAddUpdateNewsModal: (state, { payload }) => {
      return {
        ...state,
        selectNews: payload,
        isOpenAddUpdateNewsModal: true,
      };
    },
    openNewsCommentModal: (state) => {
      return {
        ...state,
        selectNews: "",
        isOpenNewsCommentModal: true,
      };
    },
    closeNewsCommentModal: (state) => {
      return {
        ...state,
        isOpenNewsCommentModal: false,
      };
    },
    closeAddUpdateNewsModal: (state) => {
      return {
        ...state,
        isOpenAddUpdateNewsModal: false,
        selectNews: "",
      };
    },
    openNewsViewModal: (state) => {
      return {
        ...state,
        isOpenNewsViewModal: true,
      };
    },
    closeNewsViewModal: (state) => {
      return {
        ...state,
        isOpenNewsViewModal: false,
        selectNews: "",
      };
    },
    clearViewNews: (state) => {
      return {
        ...state,
        viewNews: "",
      };
    },
    clearSelectNews: (state) => {
      return {
        ...state,
        selectNews: "",
      };
    },

    updateNews: (state, { payload }) => {
      console.log("payload", payload);

      let newList = [...state.newsList];
      console.log("newList", newList);
      for (let index = 0; index < newList.length; index++) {
        if (newList[index].news_id === payload.news_id) {
          newList[index] = payload;
        }
      }
      return {
        ...state,
        newsList: newList,
      };
    },
    addToList: (state, { payload }) => {
      console.log("payload", payload);
      let newList = [...state.newsList];
      newList.push(payload);
      return {
        ...state,
        newsList: newList,
      };
    },
  },
});
export default NewsReducer;
